import CloseButton from '@component/closeButton'
import Menu from '@component/menu'
import { useMenuContext } from '@component/menu/context'
import { ShareFacebookText } from '@component/share/facebook'
import { ShareEmailText } from '@component/share/email'
import { ShareLinkText } from '@component/share/link'
import { stopPropagation } from '@utils'
import { houseDetail } from '@router'
import { propertyDataLayer } from '@plugin/google/gtm/modules/property'

export default function ShareProperty({
  data
}) {

  return (
    <Menu right hover={false} width={234} popup={<ShareConent data={data}></ShareConent>} onClick={propertyDataLayer.shareClick}>
      <button className='text-primary flex items-center text-sm'>
        <i className='icon icon-share !text-3xl mr-8'></i>
        Share
      </button>
    </Menu>
  )
}

function ShareConent({
  data
}) {

  const { toggleVisible } = useMenuContext()
  const url = houseDetail(data)
  return (
    <div className='relative px-24 py-32' onClick={stopPropagation}>
      <CloseButton onClick={() => toggleVisible(false)} className='absolute right-10 top-6'></CloseButton>
      <div className='text-font text-xl leading-20'>Share this property</div>
      <div className='mt-16 space-y-16'>
        <ShareFacebookText url={url}></ShareFacebookText>
        <ShareEmailText data={data} type='house'></ShareEmailText>
        <ShareLinkText url={url}></ShareLinkText>
      </div>
    </div>
  )
}